(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1475],{

/***/ 81475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Post_PostForm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(56312);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(37887);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Label-86b7bb91.js
var Label_86b7bb91 = __webpack_require__(21976);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Select-c49c092e.js + 1 modules
var Select_c49c092e = __webpack_require__(1099);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./koba/components/Modal/ModalBody/index.js
var ModalBody = __webpack_require__(68147);
// EXTERNAL MODULE: ./koba/components/Modal/ModalFooter/ModalFooter.js
var ModalFooter = __webpack_require__(21838);
;// CONCATENATED MODULE: ./koba/components/Modal/ModalFooter/index.js


// EXTERNAL MODULE: ./koba/components/Button/index.ts
var Button = __webpack_require__(99438);
// EXTERNAL MODULE: ./koba/components/Input/index.js + 1 modules
var Input = __webpack_require__(44586);
// EXTERNAL MODULE: ./components/ExpandableTextArea/index.ts + 4 modules
var ExpandableTextArea = __webpack_require__(52655);
// EXTERNAL MODULE: ./components/Mentions/MentionsTextArea/index.ts + 5 modules
var MentionsTextArea = __webpack_require__(93852);
// EXTERNAL MODULE: ./components/AttachmentButtons/index.ts + 12 modules
var AttachmentButtons = __webpack_require__(40294);
// EXTERNAL MODULE: ./components/AttachmentFileInput/AttachmentAltTextInput.tsx
var AttachmentAltTextInput = __webpack_require__(27105);
// EXTERNAL MODULE: ./schema/Section/queries.ts
var queries = __webpack_require__(47653);
// EXTERNAL MODULE: ./constants/featureFlags.ts
var constants_featureFlags = __webpack_require__(46139);
// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
;// CONCATENATED MODULE: ./schema/Post/index.ts


var attachment = lib/* object */.Ry({
    altText: lib/* string */.Z_().optional(),
    attachmentType: lib/* string */.Z_().optional(),
    attachmentUrl: lib/* string */.Z_().optional(),
    fileName: lib/* string */.Z_().optional().nullable(),
    fileSizeInBytes: lib/* number */.Rx().optional().nullable(),
    filestackId: lib/* string */.Z_().optional(),
    s3Bucket: lib/* string */.Z_().optional(),
    s3Key: lib/* string */.Z_().optional(),
    url: lib/* string */.Z_().optional()
}).optional().nullable();
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var getAttachmentSchema = function() {
    return attachment;
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var getSchema = function(tFunc) {
    var t = tFunc || function(s) {
        return s;
    }; // Needed for custom messages
    return lib/* object */.Ry({
        title: lib/* string */.Z_().max(constants/* MAX_POST_TITLE_LENGTH */.D0).refine(function(val) {
            return val === null || val === void 0 ? void 0 : val.trim();
        }, {
            message: t("It must have at least one character other than blank space.")
        }),
        content: lib/* string */.Z_().default(""),
        spaceId: lib/* string */.Z_().refine(function(val) {
            return val === null || val !== "no-space-selected";
        }, {
            message: t("Please select a valid space.")
        }),
        attachmentAltText: lib/* string */.Z_().optional(),
        attachment: attachment
    });
};

// EXTERNAL MODULE: ./components/Forms/utils/defaultErrorMap.ts
var defaultErrorMap = __webpack_require__(65572);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(90698);
// EXTERNAL MODULE: ./helpers/setHelpers/index.ts
var setHelpers = __webpack_require__(95642);
// EXTERNAL MODULE: ./utils/routerHelpers.ts
var routerHelpers = __webpack_require__(4154);
// EXTERNAL MODULE: ./components/Forms/Post/PostForm.module.scss
var PostForm_module = __webpack_require__(28230);
var PostForm_module_default = /*#__PURE__*/__webpack_require__.n(PostForm_module);
;// CONCATENATED MODULE: ./components/Forms/Post/PostForm.tsx































var cx = bind_default().bind((PostForm_module_default()));
var PostForm = function(param) {
    var closeModal = param.closeModal, hasAutoFocus = param.hasAutoFocus, isLoading = param.isLoading, onSubmit = param.onSubmit, initValues = param.initValues, primaryColor = param.primaryColor, s3UploadPath = param.s3UploadPath, submitLabel = param.submitLabel, setIsFormDirty = param.setIsFormDirty, setUsersMentioned = param.setUsersMentioned, usersMentioned = param.usersMentioned;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8 = (0,CommunityContext/* useCommunityContext */.v1)(), featureFlags = ref8.featureFlags, community = ref8.community;
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var t = (0,es/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    var pathname = router.pathname;
    var ref9 = (0,react.useState)(false), isUploading = ref9[0], setIsUploading = ref9[1];
    var ref10 = (0,react.useState)((ref = initValues.attachment) === null || ref === void 0 ? void 0 : ref.attachmentType), attachmentType = ref10[0], setAttachmentType = ref10[1];
    var isPhone = width < constants/* SCREEN_PHONE */.SO;
    var isCoursesToCommunitiesEnabled = featureFlags[constants_featureFlags/* features.COURSES_TO_COMMUNITIES */.R.COURSES_TO_COMMUNITIES];
    var spacesInputPages = [
        routerHelpers/* pathnames.home */.$O.home
    ];
    var showSpacesInputPages = spacesInputPages.includes(pathname);
    var data = (0,useQuery/* useQuery */.a)(queries/* SECTION_QUERY */.z, {
        variables: {
            communityId: community.id,
            isCoursesToCommunitiesEnabled: isCoursesToCommunitiesEnabled
        }
    }).data;
    var defaultSpaceOption = {
        value: "no-space-selected",
        text: (0,lodash.capitalize)(t("components-forms-post-postForm-select_a_space", "Select a space"))
    };
    var communitySectionsEdges = data === null || data === void 0 ? void 0 : (ref1 = data.community) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.communitySections) === null || ref2 === void 0 ? void 0 : ref2.edges;
    var spacesList = initValues && initValues.spaceId ? [] : [
        defaultSpaceOption
    ];
    if (communitySectionsEdges && ((ref3 = communitySectionsEdges[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.node) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.communitySpaces) === null || ref5 === void 0 ? void 0 : ref5.edges)) {
        var ref11, ref12, ref13, ref14;
        var spaces = (ref11 = communitySectionsEdges[0]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.node) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.communitySpaces) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.edges) === null || ref14 === void 0 ? void 0 : ref14.map(function(edge) {
            var ref, ref1;
            return {
                value: (edge === null || edge === void 0 ? void 0 : (ref = edge.node) === null || ref === void 0 ? void 0 : ref.id) || "",
                text: (edge === null || edge === void 0 ? void 0 : (ref1 = edge.node) === null || ref1 === void 0 ? void 0 : ref1.name) || ""
            };
        });
        spacesList = (0,_to_consumable_array/* default */.Z)(spacesList).concat((0,_to_consumable_array/* default */.Z)(spaces));
    }
    var ref15 = (0,index_esm/* useForm */.cI)({
        resolver: (0,zod/* zodResolver */.F)(getSchema(t), {
            errorMap: (0,defaultErrorMap/* getErrorMap */.P)(t)
        }),
        defaultValues: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initValues), {
            spaceId: initValues.spaceId || ((ref6 = spacesList[0]) === null || ref6 === void 0 ? void 0 : ref6.value)
        })
    }), control = ref15.control, _formState = ref15.formState, errors = _formState.errors, dirtyFields = _formState.dirtyFields, getValues = ref15.getValues, handleSubmit = ref15.handleSubmit, setValue = ref15.setValue;
    var isEditing = (ref7 = initValues.title) === null || ref7 === void 0 ? void 0 : ref7.trim();
    (0,react.useEffect)(function() {
        setIsFormDirty(Object.keys(dirtyFields).length > 0);
    }, [
        Object.keys(dirtyFields).length > 0
    ]);
    var handleAttachmentChange = (0,react.useCallback)(function(attachment) {
        setIsUploading(false);
        setAttachmentType(attachment === null || attachment === void 0 ? void 0 : attachment.attachmentType);
        setValue("attachment", attachment, {
            shouldDirty: true
        });
        if (!attachment) {
            setValue("attachmentAltText", "", {
                shouldDirty: true
            });
        }
    }, [
        getValues("attachment")
    ]);
    var handleMentionChange = function(value, onChange, mentions) {
        onChange(value);
        if (setUsersMentioned) {
            var mentionedIds = mentions === null || mentions === void 0 ? void 0 : mentions.map(function(mention) {
                return mention === null || mention === void 0 ? void 0 : mention.id;
            });
            if (!(0,setHelpers/* areEqualSets */.s)(mentionedIds, usersMentioned)) {
                setUsersMentioned(mentionedIds);
            }
        }
    };
    var isDisabled = isLoading || isUploading || !(Object.keys(dirtyFields).length > 0) || Object.keys(errors).length > 0;
    var spacesInput = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: cx("select-group"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
            control: control,
            name: "spaceId",
            render: function(param) {
                var field = param.field;
                var ref, ref1;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Label_86b7bb91.L, {
                            children: t("components-forms-post-postForm-post_in_space_label", "Post in Space")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Select_c49c092e.S, {
                            dataQA: "space-select",
                            errorText: (ref = errors.spaceId) === null || ref === void 0 ? void 0 : ref.message,
                            options: spacesList,
                            selectLabel: ((ref1 = spacesList.find(function(space) {
                                return (space === null || space === void 0 ? void 0 : space.value) === field.value;
                            })) === null || ref1 === void 0 ? void 0 : ref1.text) || t("components-forms-post-postForm-select_a_space", "Select a Space"),
                            wrapperClass: cx("select-space"),
                            onSelect: field.onChange
                        })
                    ]
                });
            }
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx("create-post"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBody/* default */.Z, {
                children: [
                    (showSpacesInputPages || isEditing) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: spacesInput
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: cx("form-group"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                            control: control,
                            name: "title",
                            render: function(param) {
                                var field = param.field;
                                var ref, ref1;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    extraProps: {
                                        autoComplete: "off",
                                        maxLength: constants/* MAX_POST_TITLE_LENGTH */.D0,
                                        "data-qa": "create-post-title__textfield"
                                    },
                                    formText: ((ref = errors.title) === null || ref === void 0 ? void 0 : ref.message) || t("Max {{characterCount}} characters", {
                                        characterCount: constants/* MAX_POST_TITLE_LENGTH */.D0
                                    }),
                                    handleChange: field.onChange,
                                    hasAutoFocus: hasAutoFocus,
                                    hasError: !!((ref1 = errors.title) === null || ref1 === void 0 ? void 0 : ref1.message),
                                    id: "postTitle",
                                    initValue: field.value,
                                    label: t("Post title"),
                                    name: "postTitle",
                                    placeholder: t("Post title"),
                                    type: "text",
                                    required: true
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: cx("form-group"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                            control: control,
                            name: "content",
                            render: function(param) {
                                var field = param.field;
                                var mentionsComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(MentionsTextArea["default"], {
                                    additionalClassName: "post-form__modal",
                                    id: "postContent",
                                    placeholder: t("Type @ to mention another member in your post"),
                                    relevantMentions: [],
                                    textAreaClassName: "mentions__text-area",
                                    value: field.value || "",
                                    isModal: true,
                                    isPostForm: true,
                                    onChange: function(_event, newValue, _newPlaintextValue, mentions) {
                                        return handleMentionChange(newValue, field.onChange, mentions);
                                    }
                                });
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableTextArea/* default */.Z, {
                                    color: primaryColor,
                                    handleInputChange: field.onChange,
                                    id: "postContent",
                                    label: t("Post (optional)"),
                                    mentionsComponent: mentionsComponent,
                                    t: t,
                                    value: field.value || "",
                                    isAlwaysExpanded: true,
                                    isModal: true
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                        control: control,
                        name: "attachment",
                        render: function(param) {
                            var field = param.field;
                            // In create new, this is filestack file, in edit, this is attachment from graphql
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AttachmentButtons/* default */.Z, {
                                attachment: field.value,
                                isDisabled: !!field.value,
                                s3UploadPath: s3UploadPath,
                                isPostForm: true,
                                onChange: handleAttachmentChange,
                                onUploading: (0,react.useCallback)(function() {
                                    return setIsUploading(true);
                                }, [
                                    field.value, 
                                ])
                            });
                        }
                    }),
                    attachmentType === "image" && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                        control: control,
                        name: "attachmentAltText",
                        render: function(param) {
                            var field = param.field;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AttachmentAltTextInput/* default */.Z, {
                                t: t,
                                value: field.value || "",
                                onChange: field.onChange
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalFooter/* default */.Z, {
                children: [
                    !isPhone && /* @ts-ignore */ /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                        appearance: "ghost",
                        dataQA: "create-post-cancen-btn__button",
                        id: "cancel-post",
                        onClick: closeModal,
                        children: t("common-cancel", "Cancel")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                        appearance: "default",
                        color: primaryColor,
                        "data-qa": "create-post-btn__button",
                        id: "save-post",
                        isDisabled: isDisabled,
                        type: "button",
                        onClick: handleSubmit(onSubmit),
                        children: submitLabel
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Post_PostForm = (PostForm);

;// CONCATENATED MODULE: ./components/Forms/Post/index.ts



/***/ }),

/***/ 65572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ getErrorMap; }
/* harmony export */ });
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1604);

/* This should implement https://github.com/colinhacks/zod/blob/master/src/ZodError.ts#L242 but i18n-ized */ var getErrorMap = function(t) {
    return function(error, ctx) {
        if (error.message) return {
            message: error.message
        };
        var message;
        switch(error.code){
            case zod__WEBPACK_IMPORTED_MODULE_0__/* .ZodIssueCode.invalid_type */ .NL.invalid_type:
                if (error.received === "undefined") {
                    message = t("Required");
                } else {
                    message = t("Expected {{expectedInputType}}, received {{receivedInputType}}", {
                        expectedInputType: error.expected,
                        receivedInputType: error.received
                    });
                }
                break;
            case zod__WEBPACK_IMPORTED_MODULE_0__/* .ZodIssueCode.unrecognized_keys */ .NL.unrecognized_keys:
                message = "Unrecognized key(s) in object: ".concat(error.keys.map(function(k) {
                    return "'".concat(k, "'");
                }).join(", ")); // Developer only error message
                break;
            case zod__WEBPACK_IMPORTED_MODULE_0__/* .ZodIssueCode.invalid_union */ .NL.invalid_union:
                message = t("Invalid input");
                break;
            case zod__WEBPACK_IMPORTED_MODULE_0__/* .ZodIssueCode.invalid_enum_value */ .NL.invalid_enum_value:
                message = t("Input must be one of these values: {{valueList}}", {
                    valueList: error.options.join(", ")
                });
                break;
            case zod__WEBPACK_IMPORTED_MODULE_0__/* .ZodIssueCode.invalid_arguments */ .NL.invalid_arguments:
                message = "Invalid function arguments"; // Developer only error message
                break;
            case zod__WEBPACK_IMPORTED_MODULE_0__/* .ZodIssueCode.invalid_return_type */ .NL.invalid_return_type:
                message = "Invalid function return type"; // Developer only error message
                break;
            case zod__WEBPACK_IMPORTED_MODULE_0__/* .ZodIssueCode.invalid_date */ .NL.invalid_date:
                message = t("Invalid date");
                break;
            case zod__WEBPACK_IMPORTED_MODULE_0__/* .ZodIssueCode.invalid_string */ .NL.invalid_string:
                switch(error.validation){
                    case "email":
                        message = t("Invalid email");
                        break;
                    case "url":
                        message = t("Invalid URL");
                        break;
                    case "uuid":
                        message = t("Invalid UUID");
                        break;
                    case "regex":
                    default:
                        message = t("Invalid");
                        break;
                }
                break;
            case zod__WEBPACK_IMPORTED_MODULE_0__/* .ZodIssueCode.too_small */ .NL.too_small:
                switch(error.type){
                    case "array":
                        if (error.inclusive) {
                            message = t("Should have at least {{itemCount}} items", {
                                itemCount: error.minimum
                            });
                        } else {
                            message = t("Should have more than {{itemCount}} items", {
                                itemCount: error.minimum
                            });
                        }
                        break;
                    case "string":
                        if (error.inclusive) {
                            message = t("Should be at least {{characterCount}} characters", {
                                characterCount: error.minimum
                            });
                        } else {
                            message = t("Should be more than {{characterCount}} characters", {
                                characterCount: error.minimum
                            });
                        }
                        break;
                    case "number":
                        if (error.inclusive) {
                            message = t("Value should be greater than {{number}}", {
                                number: error.minimum
                            });
                        } else {
                            message = t("Value should be greater than or equal to {{number}}", {
                                number: error.minimum
                            });
                        }
                        break;
                    default:
                        message = t("Invalid input");
                        break;
                }
                break;
            case zod__WEBPACK_IMPORTED_MODULE_0__/* .ZodIssueCode.too_big */ .NL.too_big:
                switch(error.type){
                    case "array":
                        if (error.inclusive) {
                            message = t("Should have at most {{itemCount}} items", {
                                itemCount: error.maximum
                            });
                        } else {
                            message = t("Should have less than {{itemCount}} items", {
                                itemCount: error.maximum
                            });
                        }
                        break;
                    case "string":
                        if (error.inclusive) {
                            message = t("Should be at most {{characterCount}} characters", {
                                characterCount: error.maximum
                            });
                        } else {
                            message = t("Should be less than {{characterCount}} characters", {
                                characterCount: error.maximum
                            });
                        }
                        break;
                    case "number":
                        if (error.inclusive) {
                            message = t("Value should be less than or equal to {{number}}", {
                                number: error.maximum
                            });
                        } else {
                            message = t("Value should be less than {{number}}", {
                                number: error.maximum
                            });
                        }
                        break;
                    default:
                        message = t("Invalid input");
                        break;
                }
                break;
            default:
                message = ctx.defaultError;
                throw new Error(message);
        }
        return {
            message: message
        };
    };
};



/***/ }),

/***/ 95642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ areEqualSets; }
/* harmony export */ });
/* harmony import */ var lodash_xor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76566);
/* harmony import */ var lodash_xor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_xor__WEBPACK_IMPORTED_MODULE_0__);

var areEqualSets = function(listA, listB) {
    if (!listA || !listB) return false;
    return lodash_xor__WEBPACK_IMPORTED_MODULE_0___default()(listA, listB).length === 0;
};



/***/ }),

/***/ 68147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _ModalBody__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _ModalBody__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94000);



/***/ }),

/***/ 28230:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"PostForm_sr-only--mobile__LEjMt","sr-only":"PostForm_sr-only__XsE2D","error-message":"PostForm_error-message__rABBT","form-inline-edit":"PostForm_form-inline-edit__GgnHh","form-group":"PostForm_form-group__aYh_N","form-row":"PostForm_form-row__g8JGD","form-inline":"PostForm_form-inline__7blqt","error":"PostForm_error__jrfCR","input-group-append":"PostForm_input-group-append__2soXa","input-group-currency":"PostForm_input-group-currency__JE3jB","form-control":"PostForm_form-control__HDICV","custom-select":"PostForm_custom-select__MB6K1","is-invalid":"PostForm_is-invalid__We4b8","is-valid":"PostForm_is-valid__xDsm3","input-group":"PostForm_input-group__dHY4l","input-group-text":"PostForm_input-group-text__aLHeE","input-group-prepend":"PostForm_input-group-prepend__JIQPv","valid-feedback":"PostForm_valid-feedback__oyJSX","invalid-feedback":"PostForm_invalid-feedback__FQjL6","form-text":"PostForm_form-text__jjAdO","label":"PostForm_label__oY5ir","custom-control":"PostForm_custom-control__TgscR","custom-control-label":"PostForm_custom-control-label__Wr1Q3","custom-control-label--empty":"PostForm_custom-control-label--empty__U10Qs","custom-control-input":"PostForm_custom-control-input__WCUB5","create-post":"PostForm_create-post__3nrSS","create-post__button":"PostForm_create-post__button__kS6QH","create-post__button--dark-text":"PostForm_create-post__button--dark-text__Hns9c","select-group":"PostForm_select-group__zwEUf","select-space":"PostForm_select-space__sNJ_j"};

/***/ })

}]);